'use client';
import { useRef } from 'react';
import { compare } from '../utils/compare.js';

function useGuaranteedMemo(factory, deps) {
    const ref = useRef();
    if (!ref.current || deps.length !== ref.current.prevDeps.length || !compare(ref.current.prevDeps, deps)) {
        ref.current = {
            value: factory(),
            prevDeps: [
                ...deps
            ]
        };
    }
    return ref.current.value;
}

export { useGuaranteedMemo };
//# sourceMappingURL=useGuaranteedMemo.js.map
